module.exports = __webpack_public_path__ + "static/media/lever-base@2x.89fce10a.png";